import React from 'react'
import { Container } from 'react-bootstrap'


const Blogs = () => {
  return (
     <Container fluid className='project-section'>
         <h1 className='text-white'>COMING SOON </h1>
     </Container>
  )
}

export default Blogs